import { Conditions, getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getColorFilterConfig } from '../filters/color';
import { MediaPayload } from '../configHelper';

const portlandleatherSizes: string[] = [
  'X-Small',
  'Small',
  'Medium',
  'Large',
  'X-Large',
  'XX-Large',
  'Oversized',
  '5.5',
  '6',
  '6.5',
  '7',
  '7.5',
  '8',
  '8.5',
  '9',
  '9.5',
  '10',
  '10.5',
  '11',
  '11.5',
  '12',
  '12.5',
  '13',
];
const portlandleatherAdditionalPayoutSettings = {
  additionalShopifyGiftCardRequirements: {
    giftCardExpiresAfterDays: 365, // 1 year
  },
  creditCodeHelperText: 'Credits expire 1 year after date of issue.',
};

const getMediaForProduct = (media?: MediaPayload[]) => {
  // Remove images with Out of stock notice in alt text
  if (!media) return [];
  return media.filter((mediaItem) => {
    const altText = mediaItem.alt;
    return !altText?.includes('Out of stock notice');
  });
};

const getMediaForVariant = (
  media?: MediaPayload[],
  selectedVariantOptions?: Record<string, string | null>
) => {
  if (!media) return [];

  // first, also filter out the images with Out of stock notice in alt text
  const filteredMedia = getMediaForProduct(media);

  const normalizeText = (text?: string) =>
    text
      ?.toLowerCase()
      .replace(/[-_]/g, ' ') // replace all - and _
      .replace(/\.[^/.]+$/, '') // drop file extension
      .split('?')[0]; // drop query params
  const color = selectedVariantOptions?.color ?? '';
  const normalizedColor = normalizeText(color);

  return filteredMedia.filter((mediaItem) => {
    const normalizedUrl = normalizeText(mediaItem.url);
    const altText = mediaItem.alt;
    return (
      normalizedColor &&
      (normalizedUrl?.includes(normalizedColor) || altText?.includes(normalizedColor))
    );
  });
};

const portlandleatherConditionsOptions = [
  {
    key: Conditions.NewWithoutTags,
    label: 'New',
    description:
      'Your item has never been worn (other than perhaps trying it on). There are no quirks or issues whatsoever.',
  },
  {
    key: Conditions.Excellent,
    label: 'Excellent',
    description:
      'Your item has only been lightly used and has been extremely well maintained. There may be some small signs of wear, but nothing major.',
  },
  {
    key: Conditions.Good,
    label: 'Good',
    description:
      'You’ve worn this item and it’s well maintained. There may be some quirks like a small stain, a button missing, or a loose thread, but it’s overall in good shape. You will need to take pictures of any quirks the item has.',
  },
];

export const portlandleatherShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig({
      options: portlandleatherConditionsOptions,
    }),
    getColorFilterConfig(),
    getSizeFilterConfig({ sizes: portlandleatherSizes }),
  ],
  additionalPayoutSettings: portlandleatherAdditionalPayoutSettings,
  // customizable name for store credit
  storeCreditName: 'merchandise credit',
  getMediaForProduct,
  getMediaForVariant,
};
